import { FunctionComponent, Ref, useState } from 'react';
import { Button, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { z } from 'zod';
import { clientActionSchema } from '../hooks/uiComponentsSchemas';

const ClientActionComponentWrapper = styled.div`
  align-self: flex-end;
  padding-left: ${spacingHelper('medium')};
  padding-right: ${spacingHelper('medium')};
  gap: ${spacingHelper('extraSmall')};
  display: flex;
`;
interface ClientActionButtonsProps {
  actions: z.infer<typeof clientActionSchema>[];
  onActionClick: (action: z.infer<typeof clientActionSchema>) => void;
  userInteractionRef?: Ref<HTMLDivElement>;
}

export const ClientActionButtons: FunctionComponent<ClientActionButtonsProps> = ({
  actions,
  onActionClick,
  userInteractionRef,
}) => {
  const [clicked, setClicked] = useState<string | null>(null);

  const handleClick = (action: z.infer<typeof clientActionSchema>) => {
    if (clicked === null) {
      setClicked(action.text);
      onActionClick(action);
    }
  };

  return (
    <ClientActionComponentWrapper ref={userInteractionRef}>
      {actions.map((action, index) => (
        <Button
          key={index}
          variant="outline-secondary"
          sizeVariant="medium"
          disabled={clicked !== null && clicked !== action.text}
          onClick={() => !clicked && handleClick(action)}
        >
          {action.text}
        </Button>
      ))}
    </ClientActionComponentWrapper>
  );
};
